import { useFormContext } from "react-hook-form";
import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import {
  FilterSelectionFlow,
  FilterType,
  IFilter,
} from "@asayinc/component-library";
import { useMemo, forwardRef, Ref } from "react";
import { useGetStateFilterOptionsQuery } from "../../../../store/staticJson";
import { FILTER_MESSAGING_MAP } from "../../../../constants";

interface IProps {
  updateUrl?: boolean;
  isLoading?: boolean;
  onClose?: () => void;
}

const StateFilter = (
  { updateUrl = false, isLoading, onClose }: IProps,
  ref: Ref<{ triggerPopover: () => void }> // used to simulate click event on chip from parent
) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [firstRender, setFirstRender] = useState(true);
  const { data: stateData, isLoading: statesLoading } =
    useGetStateFilterOptionsQuery();

  const options = useMemo(
    () =>
      [
        {
          type: FilterType.Location,
          label: "Location selection",
          options: {
            hideSublocationIfEmpty: true,
            stateOptions: {
              multiple: false,
              optionType: "checkicon",
              groupLabel: "State",
              placeholder: "All states",
              options: statesLoading ? [] : stateData || [],
            },
            cityOptions: {
              multiple: false,
              optionType: "checkicon",
              groupLabel: "City",
              options: [],
            },
          },
        },
      ] as IFilter[],
    [stateData, statesLoading]
  );

  const { watch, setValue } = useFormContext();
  /**
   * set formValues on page load
   */
  useEffect(() => {
    if (updateUrl) {
      const state = searchParams.get("state") || undefined;
      if (state) setValue("filterMap.query.state", { values: [state] });
    }
  }, []);

  /**
   * update url params if updateURL is true
   */
  const state = watch("filterMap.query.state");
  useEffect(() => {
    // prevent running on first render to avoid duplicate history states
    if (!firstRender) {
      if (updateUrl && state?.values) {
        searchParams.set("state", state.values[0]);
        setSearchParams(searchParams);
      }
    } else {
      setFirstRender(false);
    }
  }, [state]);

  const onClear = () => {
    if (updateUrl) {
      searchParams.delete("state");
      setSearchParams(searchParams);
    }
  };

  return (
    <>
      <FilterSelectionFlow
        withinForm={{
          fieldName: "filterMap.query.state",
          fieldName2: "filterMap.query.city",
        }}
        clearable
        chipProps={{
          disabled: isLoading || statesLoading,
        }}
        onClear={onClear}
        onClose={onClose}
        ref={ref}
        testid="chip-location"
        chipLabel="Location"
        filterTypeOptions={options}
        {...FILTER_MESSAGING_MAP.location}
      />
    </>
  );
};

export default forwardRef(StateFilter);
